module.exports = __webpack_public_path__ + "img/101-el-01.prt.8e81b830.jpg";